import { render, staticRenderFns } from "./LangField.vue?vue&type=template&id=73659c0d&"
import script from "./LangField.vue?vue&type=script&lang=js&"
export * from "./LangField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports